import { requestWithToken } from '../utilities/request';
const path = '/api/private/notices';

// api :GET, '/api/private/notices/list', 'ログインユーザーの通知一覧を返します'
const list = params => {
  if (params === undefined) {
    params = {};
  }
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/list`),
    params,
    isQuiet: params.isQuiet || false,
  });
};

const systemList = params => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/system_lists`),
    params,
  });
};

const read = noticeId => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/read`),
    params: {
      notice_id: noticeId,
    },
  });
};

/**
 * @description 未入力作業実績登録
 */
const registerUnentered = params => {
  return requestWithToken({
    method: 'POST',
    url: path.concat('/register_unentered'),
    params,
  });
};

export const NotificationService = {
  list,
  read,
  systemList,
  registerUnentered,
};
export default NotificationService;



// WEBPACK FOOTER //
// ./src/services/Notification.js